export default __webpack_public_path__ + "static/media/twitterIcon.8c955e06.svg";